/**
 * Componente principal da aplicação Atomic.Digital
 * Configuração de rotas e tema
 */

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider, createTheme } from '@mui/material';
import { store } from './store';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import SearchPage from './pages/SearchPage';
import TasksPage from './pages/TasksPage';
import LeadsPage from './pages/LeadsPage';
import PendingApprovalPage from './pages/PendingApprovalPage';
import UsersManagementPage from './pages/UsersManagementPage';

// Tema personalizado com cores da Atomic.Digital
const theme = createTheme({
  palette: {
    primary: {
      main: '#FF6B35',
    },
    secondary: {
      main: '#000000',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
});

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <Router>
            <Routes>
              {/* Página pública */}
              <Route path="/" element={<LoginPage />} />
              
              {/* Página de aguardando aprovação (não precisa de aprovação) */}
              <Route path="/pending-approval" element={<PendingApprovalPage />} />
              
              {/* Rotas protegidas (requerem aprovação) */}
              <Route path="/app" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/app/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/app/search" element={<ProtectedRoute><SearchPage /></ProtectedRoute>} />
              <Route path="/app/tasks" element={<ProtectedRoute><TasksPage /></ProtectedRoute>} />
              <Route path="/app/leads" element={<ProtectedRoute><LeadsPage /></ProtectedRoute>} />
              <Route path="/app/users" element={<ProtectedRoute><UsersManagementPage /></ProtectedRoute>} />
              <Route path="/app/settings" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              
              {/* Fallback */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
